<div
  [ngClass]="isMinimized() ? 'tw:hidden!' : 'tw:flex tw:flex-col'"
  class="ai-chat-panel">
  <div class="ai-chat-toolbar">
    <div class="ai-chat-toolbar__title">
      <span
        class="corra-bot-icon"
        aria-hidden="true">
        <i class="pi pi-sparkles"></i>
      </span>
      <span class="ai-chat-title">{{ botName() }}</span>
    </div>
    <div class="ai-chat-toolbar__actions">
      <button
        test-id="ai-chat-new-chat"
        type="button"
        class="chat-bot-action-btn"
        pTooltip="New chat"
        (click)="onNewChatClick()"
        tooltipPosition="bottom">
        <i class="pi pi-plus"></i>
      </button>
      <!-- <button
        type="button"
        class="chat-bot-action-btn"
        [pTooltip]="'History' "
        (click)="onHistoryClick()"
        tooltipPosition="bottom">
        <i class="pi pi-history"></i>
      </button> -->
      @if (showCloseButton()) {
        <button
          test-id="ai-chat-close"
          type="button"
          class="chat-bot-action-btn"
          pTooltip="Close"
          (click)="onMinimizeChatClick()"
          tooltipPosition="left"
          tooltipStyleClass="ai-chat-tooltip-left">
          <i class="pi pi-arrow-right"></i>
        </button>
      }
    </div>
  </div>

  <cor-ai-chat-message-list
    class="ai-chat-body"
    [messages]="messages()"
    [botName]="botName()"
    [initialMessages]="initialMessages()"
    (initialMessageClick)="onInitialMessageClick($event)"
    (copyClick)="copyMessage($event)"
    (retryClick)="onRetry()" />

  <cor-ai-chat-input
    [(selectedModel)]="selectedModel"
    [disabled]="isLoading()"
    [isLoading]="isLoading()"
    placeholder="Type a message..."
    (send)="onUserSend($event)"
    (abortRequest)="onAbort()" />

  <div class="ai-chat-disclaimer">AI can make mistakes, so double check it.</div>
</div>
